import { useToastedMutation } from './use-toasted-mutation';
import { useAutoEnrollmentService } from './use-auto-enrollment-service';
import { useCandidatesCache } from './use-candidates-cache';
import { useCourseEnrollees } from './use-course-enrollees';
import { useCallback } from 'react';

export const useEnrollmentFilanizer = () => {
    const { courseEnrollees } = useCourseEnrollees();
    const { clearCache } = useCandidatesCache();
    const autoEnrollmentService = useAutoEnrollmentService();
    const [ finalizeEnrollment, { isLoading }] = useToastedMutation({
        mutationFn: () => autoEnrollmentService.submitCourseEnrollees(courseEnrollees),
        onSuccess: () => clearCache()
    });

    return {
        finalizeEnrollment,
        isLoading
    };
};
